<template>
  <div class="promotion-page">
    <el-button class="import-page-upload-text campaign-management-btn" type="text" size="mini" @click="onClickRouteCP()">{{ $t('promomgmt.t17') }}</el-button>
    <el-button class="import-page-upload-btn campaign-management-btn" type="danger" size="mini" @click="onClickUpload()">{{ $t('promomgmt.t7') }}</el-button>

    <div class="page-header">
      <h2>{{ $t('promomgmt.t1') }}</h2>
    </div>

    <div class="promotion-page-table">
      <el-table :data="lists" size="mini" v-loading="tableloading">
        <el-table-column label="CampID" prop="campId" width="100"></el-table-column>
        <el-table-column :label="$t('promomgmt.t8')" prop="name"></el-table-column>
        <el-table-column :label="$t('el.datepicker.startTime')" prop="startTime" width="150"></el-table-column>
        <el-table-column :label="$t('el.datepicker.endTime')" prop="endTime" width="150"></el-table-column>
        <el-table-column :label="$t('promomgmt.t5')" prop="updateTime" width="150"></el-table-column>
        <el-table-column :label="$t('dsfx.t27')" prop="statusTxt" width="100">
          <template slot-scope="scope">
            <span :class="scope.row.status == 1 ? 'status-green' : 
            scope.row.status == 2 ? 'status-yellow' : 'status-grey'">{{ scope.row.statusTxt }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('activebrand.t37')" width="80">
          <template slot-scope="scope">
            <button class="delete-icon-btn viewactivebrand" @click="onClickRoute(scope.row.campId)" type="button"></button>
            <el-button :disabled="scope.row.status == 3" class="editskulinkbtn" @click="onClickEdit(scope.row)">
              <i class="el-icon-edit-outline"></i>
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  
    <el-dialog
      custom-class="promotion-dialog"
      :title="$t('promomgmt.t7')"
      :visible.sync="showdialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="true"
      :append-to-body="true"
      @close="showdialog = false">
      <div class="promotion-dialog-body">
        <el-form  size="mini" label-width="80px">
          <el-form-item :label="$t('promomgmt.t8')">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('promomgmt.t9')">
            <el-date-picker
              v-model="form.startend"
              type="datetimerange"
              range-separator="-"
              :start-placeholder="this.$t('el.datepicker.startTime')"
              :end-placeholder="$t('el.datepicker.endTime')"
              clearable
              :default-time="['00:00:00','23:59:59']"
              format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="showdialog = false;">{{$t('dsfx.t32')}}</el-button>
        <el-button size="mini" type="primary" @click="addCampaignItems()">{{$t('dsfx.t33')}}</el-button>
      </span>
    </el-dialog>
  
    <el-dialog
      custom-class="promotion-dialog"
      :label="$t('promomgmt.t16')"
      :visible.sync="showdialogedit"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="true"
      :append-to-body="true"
      @close="showdialog = false">
      <div class="promotion-dialog-body">
        <el-form  size="mini" label-width="80px">
          <el-form-item :label="$t('promomgmt.t8')">
            <el-input v-model="formedit.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('promomgmt.t9')">
            <el-date-picker
              v-model="formedit.startend"
              type="datetimerange"
              range-separator="-"
              :start-placeholder="this.$t('el.datepicker.startTime')"
              :end-placeholder="$t('el.datepicker.endTime')"
              clearable
              :default-time="['00:00:00','23:59:59']"
              format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="showdialogedit = false;">{{$t('dsfx.t32')}}</el-button>
        <el-button size="mini" type="primary" @click="updateCamp()">{{$t('dsfx.t33')}}</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
export default {
  data(){
    return{
			taskid: '',
      showdialog: false,
      showdialogedit: false,
			tableloading: false,
      lists: [],
      form: {
        name: '',
        startend: ''
      },
      formedit: {},
			page: 1,
			size: 25,
			total: 0,
      sametime: false
    }
  },

  mounted(){
		/**
		 * 获取当前订阅详情
		 */
		let that = this
		let current = that.getCurrentInfo()
		that.taskid = current.taskid

		that.getCampaignList()
		
  },

  methods: {
    
    /**
     * 上传
     */
    onClickUpload: function(){
      this.showdialog = true
    },

    /**
     * 
     * @param {*} pid
     * 跳转 
     */
    onClickRoute: function(pid){
      this.$router.push({name: 'CampaignDetailMP', params: {Id: this.$route.params.Id, Pid: pid}})
    },

    onClickRouteCP: function(){
      this.$router.push({name: 'CampaignDetailCP', params: {Id: this.$route.params.Id}})
    },

    /**
     * 
     * @param {修改促销：
      接口地址：price/activity/edit
      请求方式：post
      参数：
                campId,
                taskId,
                name ,
                startTime,
                endTime,
                status
     */
    onClickEdit: function(obj){
      let that = this
      that.showdialogedit = true
      that.formedit = {
        campId: obj.campId,
        name: obj.name,
        status: obj.status,
        startend: [obj.startTime, obj.endTime]
      }
    },

    updateCamp: function(){
      let that = this
      let data = {
        campId: that.formedit.campId,
				taskId: that.taskid,
				name: that.formedit.name,
				startTime: that.$moment(that.formedit.startend[0]).format('YYYY-MM-DD HH:mm:ss'),
				endTime: that.$moment(that.formedit.startend[1]).format('YYYY-MM-DD HH:mm:ss'),
        status: that.checkStatus(that.formedit.startend[0], that.formedit.startend[1])
			}
			let url = that.API_URL + '/v3/price/activity/edit'
      $.ajax({
        url:  url,
        type: "POST",
        data: data,
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        success: function(rex) {
          console.log('onClickEdit', rex)
					that.showdialogedit = false
					that.formedit = {}
					that.getCampaignList()
        },
        error: function(response) {
          console.log('onClickEdit', response)
        }
      })
    },

		/**
		 * 排序
		 */
		// sortColumn: function(){

		// },

		/**
		 * 添加活动
		 */
    addCampaignItems: function(){
			let that = this
			let data = {
				taskId: that.taskid,
				name: that.form.name,
				startTime: that.$moment(that.form.startend[0]).format('YYYY-MM-DD HH:mm:ss'),
				endTime: that.$moment(that.form.startend[1]).format('YYYY-MM-DD HH:mm:ss'),
			}
			let url = that.API_URL + '/v3/price/activity/add'
      $.ajax({
        url:  url,
        type: "POST",
        data: data,
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        success: function(rex) {
          console.log('addCampaignItems', rex)
          if(rex.info.info == '该时间段已存在促销活动'){
            that.sametime = true
            that.$message({
              showClose: true,
              message: that.$t('promomgmt.t10'),
              type: 'error'
            })
          } else{
            that.showdialog = false
            that.form = {
              name: '',
              startend: ''
            }
            that.getCampaignList()
          }
        },
        error: function(response) {
          console.log('addCampaignItems', response)
        }
      })
		},

		/**
		 * 获取活动列表
		 */
		getCampaignList: function(){
			let that = this
			that.tableloading = true
			let url = that.API_URL + '/v3/price/activity/paging'
			let _data = {
				taskId : that.taskid,
				page: 1,
				size: 25,
				order: '',
			}
      $.ajax({
        url:  url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
				data: _data,
        changeOrigin: true,
        crossDomain: true,
        success: function(rex) {
					console.log('getCampaignList', rex)
					let _rex = rex.results[1]
					_rex.forEach(item => {
						item.startTime = item.startTime != null && item.startTime != '' ? that.$moment(item.startTime).format('YYYY-MM-DD HH:mm') : ''
						item.endTime = item.endTime != null && item.endTime != '' ? that.$moment(item.endTime).format('YYYY-MM-DD HH:mm') : ''
						item.updateTime = item.updateTime != null && item.updateTime != '' ? that.$moment(item.updateTime).format('YYYY-MM-DD HH:mm') : ''
						item.statusTxt = item.status == 1 ? that.$t("promomgmt.t2") : item.status == 2 ? that.$t("promomgmt.t3") : item.status == 3 ? that.$t("promomgmt.t4") : ''
					})
					that.lists = _rex
					that.tableloading = false
        },
        error: function(response) {
          console.log('getCampaignList', response)
        }
      })
		},

    /**
     * 设置状态
     */
    checkStatus: function(start, end){
      let _status = 0
      let _now = new Date()
      if(new Date(start) > _now && new Date(end) > _now){
        _status = 2
      } else if(new Date(start) <= _now && new Date(end) > _now){
        _status = 1
      } else{
        _status = 3
      }
      return _status
    }

  }
}
</script>